import { useContext } from 'react';
import TranslationContext from './TranslationContext';
export default function useHelpNote() {
    return useContext(TranslationContext).getHelpNoteTooltipTitle;
}
